import VueRouter from 'vue-router';

import Autenticar from '../views/sessoes/Autenticar';
import RecuperarSenha from '../views/sessoes/RecuperarSenha';
import TelaAvisoEmail from '../views/sessoes/TelaAvisoEmail';
import RedefinirSenha from '../views/sessoes/RedefinirSenha';
import SemPermissao from '../views/SemPermissao';

import Auth from '../services/Auth';
import HomeApi from '../services/HomeApi';
import rotasPrivadas from './rotasPrivadas';
import { rotaInicial } from './helpers';

const intersection = require('lodash.intersection');

const AUTENTICAR_ROUTE = 'Autenticar';
const RECUPERAR_SENHA_ROUTE = 'RecuperarSenha';
const TELA_AVISO_EMAIL_ROUTE = 'TelaAvisoEmail';
const REDEFINIR_SENHA_ROUTE = 'RedefinirSenha';
const SEM_PERMISSAO_ROUTE = 'SemPermissao';

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/sessoes/autenticar",
      component: Autenticar,
      name: AUTENTICAR_ROUTE,
      alias: "/",
    },
    {
      path: "/sessoes/recuperar_senha",
      component: RecuperarSenha,
      name: RECUPERAR_SENHA_ROUTE,
    },
    {
      path: "/sessoes/tela_aviso_email",
      component: TelaAvisoEmail,
      name: TELA_AVISO_EMAIL_ROUTE,
    },
    {
      path: "/sessoes/redefinir_senha",
      component: RedefinirSenha,
      name: REDEFINIR_SENHA_ROUTE,
    },
    {
      path: "/sem-permissao",
      component: SemPermissao,
      name: SEM_PERMISSAO_ROUTE,
    },
    ...rotasPrivadas,
  ],
  // base: `/movimentacao/`
});

router.beforeEach(async (to, from, next) => {
    let auth = new Auth();
    let paginaAnterior = from.name;

    router.pagina_anterior = paginaAnterior;

    // se é pra rota de autenticar, mas ja esta logado
    // IMPORTANTE: Se tem token e iv na query, SEMPRE executa a autenticação (mesmo que já tenha dados no localStorage)
    const temTokenEIv = to.query.token && to.query.iv;

    if (to.name === AUTENTICAR_ROUTE && auth.loggedIn() && !temTokenEIv) {
        // ENVIA PARA PRIMEIRA ROTA QUE TEM PERMISSAO
        const rota = rotaInicial();
        if (rota) {
            next({
                name: rota.name
            })
        } else {
            // não tem permissao em nenhuma rota
            // ATENCAO, POSSIVELMENTE OCORREU ERRO EM ALGUM LUGAR, NAO DEVERIA TER PASSADO PELO LOGIN DO SGU
            // SEM TER NENHUMA PERMISSAO
            next({
                name: SEM_PERMISSAO_ROUTE
            })
        }
    } else if (to.name === AUTENTICAR_ROUTE && temTokenEIv) {
        next()
    } else if (to.matched.some(record => record.meta.requerPermissao)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!auth.loggedIn()) {
            next({
                name: AUTENTICAR_ROUTE,
                query: { redirect: to.fullPath }
            })
        } else {
            // Verifica permissões baseado no localStorage primeiro
            if (to.matched.some(record => intersection(record.meta.permissoes, auth.funcionalidades).length == 0)) {
                next({
                    name: SEM_PERMISSAO_ROUTE
                })
            } else {
                // ✨ NOVO: Valida sessão no backend antes de prosseguir (apenas verifica se expirou)
                try {
                    const homeApi = new HomeApi();
                    await homeApi.getUsuarioAtual();

                    // Sessão válida, permite navegação
                    next()
                } catch (error) {
                    // Trata apenas erro 401 (sessão expirada)
                    if (error.response && error.response.status === 401) {
                        // Sessão expirada no backend
                        localStorage.removeItem('usuario_movimentacoes_servidores');
                        next({
                            name: AUTENTICAR_ROUTE,
                            query: { redirect: to.fullPath }
                        })
                    } else {
                        // Outros erros (404, rede, etc) - permite navegação
                        // O componente individual vai lidar com o erro
                        next()
                    }
                }
            }
        }
    } else {
        next() // make sure to always call next()!
    }
});

export default router;